// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TuringHelpBtn {
  display: inline-flex;
  position: relative;
  gap: 10px;
  align-items: center;
}

.TuringHelpBtn > .TuringHelpBtnIcon .material-icons {
  color: #56A8F7;
  font-size: 21px;
  line-height: 21px;
}

.TuringHelpBtncontent {
  position: absolute;
  bottom: 30px;
  left: 10px;
  min-width: 235px;
  max-width: 300px;
  padding: 12px;
  border-radius: 7px;
  border-bottom-left-radius: 0;
  background-color: #56A8F7;
  color: #fff;
  text-align: left;
  white-space: normal;
  line-height: 20px;
  font-size: 14px;
  font-weight: normal;
  z-index: 100;
  display: none;
}

.TuringHelpBtnIcon:hover .TuringHelpBtncontent{
  display: block;
}

.TuringHelpBtnIcon {
  position: relative;
  cursor: pointer;
  display: flex;
}`, "",{"version":3,"sources":["webpack://./src/v3/legacy_components/UI_V2_Components/shared/TuringHelpBtn/TuringHelpBtn.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,4BAA4B;EAC5B,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,aAAa;AACf","sourcesContent":[".TuringHelpBtn {\n  display: inline-flex;\n  position: relative;\n  gap: 10px;\n  align-items: center;\n}\n\n.TuringHelpBtn > .TuringHelpBtnIcon .material-icons {\n  color: #56A8F7;\n  font-size: 21px;\n  line-height: 21px;\n}\n\n.TuringHelpBtncontent {\n  position: absolute;\n  bottom: 30px;\n  left: 10px;\n  min-width: 235px;\n  max-width: 300px;\n  padding: 12px;\n  border-radius: 7px;\n  border-bottom-left-radius: 0;\n  background-color: #56A8F7;\n  color: #fff;\n  text-align: left;\n  white-space: normal;\n  line-height: 20px;\n  font-size: 14px;\n  font-weight: normal;\n  z-index: 100;\n  display: none;\n}\n\n.TuringHelpBtnIcon:hover .TuringHelpBtncontent{\n  display: block;\n}\n\n.TuringHelpBtnIcon {\n  position: relative;\n  cursor: pointer;\n  display: flex;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
